import { StandardQuizQuestion } from '@/types/quizTypes';

export const VERCEL_EDGE_FUNCTIONS_QUIZ: StandardQuizQuestion[] = [
  {
    id: "vercel-edge-1",
    question: "What runtime do Vercel Edge Functions use?",
    options: [
      "Node.js",
      "Edge Runtime (based on V8)",
      "Deno",
      "Python"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Vercel Edge Functions run on the Edge Runtime, which is based on the V8 JavaScript engine. This is lighter than full Node.js and enables faster cold starts.",
    category: "runtime",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "vercel-edge-2",
    question: "What is the main benefit of Edge Functions compared to serverless functions?",
    options: [
      "Larger memory limits",
      "Lower latency due to global distribution",
      "More CPU power",
      "Longer execution time"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Edge Functions run close to users globally, reducing latency. They execute at the edge locations nearest to the request origin, improving response times significantly.",
    category: "performance",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "vercel-edge-3",
    question: "What is Edge Middleware in Next.js?",
    options: [
      "A database connector",
      "Code that runs before a request is processed",
      "A CSS framework",
      "A testing library"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Edge Middleware runs before a request is completed, enabling authentication, redirects, header manipulation, and A/B testing at the edge before reaching your application.",
    category: "middleware",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "vercel-edge-4",
    question: "How do you read request data in an Edge Function?",
    options: [
      "Using req.body directly",
      "Using await request.json() or request.text()",
      "Using fs.readFile()",
      "Using process.env.REQUEST"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Edge Functions use Web APIs. The Request object provides methods like .json(), .text(), .formData() to read the request body asynchronously.",
    category: "request-handling",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "vercel-edge-5",
    question: "What are the limitations of Edge Runtime compared to Node.js?",
    options: [
      "Can't use JavaScript",
      "No access to Node.js APIs like fs, child_process",
      "Can't handle HTTP requests",
      "No JSON support"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Edge Runtime doesn't support Node.js-specific APIs (fs, child_process, etc.). It uses Web Standard APIs only, which enables faster cold starts but limits some functionality.",
    category: "limitations",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "vercel-edge-6",
    question: "How do you enable streaming responses in Edge Functions?",
    options: [
      "Use StreamResponse class",
      "Return a ReadableStream in Response body",
      "Use response.stream() method",
      "Streaming is not supported"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Edge Functions support streaming by returning a Response with a ReadableStream as the body. This enables progressive rendering and large data transfers.",
    category: "streaming",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "vercel-edge-7",
    question: "What is the purpose of edge caching?",
    options: [
      "Store user sessions",
      "Cache responses at edge locations for faster subsequent requests",
      "Backup database",
      "Log analytics"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Edge caching stores responses at edge locations globally. Subsequent requests from nearby users get cached responses, reducing latency and origin load.",
    category: "caching",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "vercel-edge-8",
    question: "What causes cold starts in Edge Functions?",
    options: [
      "Database connections",
      "First invocation in a region or after period of inactivity",
      "Large file uploads",
      "Network errors"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Cold starts occur when a function is invoked for the first time in a region or after being idle. Edge Runtime's lightweight design minimizes cold start times compared to full Node.js.",
    category: "performance",
    points: 15,
    type: "multiple-choice"
  }
];

export const generateVercelEdgeFunctionsQuiz = () => ({
  questions: VERCEL_EDGE_FUNCTIONS_QUIZ,
  passThreshold: 80,
  timeLimit: 900,
  category: 'edge-computing'
});
